import React from 'react';
import './AccessDenied.css';

/**
 * Access Denied Page - User Friendly Version
 * Shown when user doesn't have valid authentication
 * Redirects to OneClick Trading login
 */
function AccessDenied({ error }) {
  const handleLoginClick = () => {
    window.location.href = 'https://app.oneclicktrading.com';
  };

  return (
    <div className="access-denied">
      <div className="access-denied-container">
        {/* Friendly Icon */}
        <div className="access-denied-icon">
          👋
        </div>

        {/* Title */}
        <h1 className="access-denied-title">Market Matrix</h1>

        {/* Friendly Message */}
        <p className="access-denied-message">
          To get started, please sign in to your OneClick Trading account.
        </p>

        <p className="access-denied-submessage">
          Your trading dashboard is just one click away!
        </p>

        {/* Login Button */}
        <button className="access-denied-btn" onClick={handleLoginClick}>
          <span className="btn-icon">✨</span>
          <span>Sign In to OneClick Trading</span>
          <span className="btn-arrow">→</span>
        </button>

        {/* Benefits Section */}
        <div className="benefits-section">
          <div className="benefit-item">
            <span className="benefit-icon">📊</span>
            <span className="benefit-text">Live Trade Tracking</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">🎯</span>
            <span className="benefit-text">Real-Time Alerts</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">⚡</span>
            <span className="benefit-text">Performance Analytics</span>
          </div>
        </div>

        {/* Help Text */}
        <div className="help-section">
          <p className="help-title">🔒 Secure & Simple</p>
          <p className="help-text">
            Sign in with your OneClick Trading account to access your personalized trading dashboard and live performance analytics.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AccessDenied;
